
import { RegisterUserInfo } from "store/auth.module";

/* eslint-disable @typescript-eslint/camelcase */
import { BaseButton, BaseText } from "components/atoms";
import { InputField } from "components/molecules";
import { useRegisterForm } from "composables/useRegisterForm";
import { useEmitter } from "hooks/useEmitter";

import { iconN } from "assets/icons";

interface Events {
  "on-register-submit": RegisterUserInfo;
}

export default {
  name: "RegisterForm",
  components: { BaseButton, BaseText, InputField },
  setup() {
    // Import everything we need from the registration composable
    const {
      userEmail,
      userName,
      userPassword,
      v,
      handleBlur,
    } = useRegisterForm();

    const emitter = useEmitter<Events>();

    const handleOnSubmit = () => {
      // Validate the inputs
      v.value.$touch();

      // Make sure that all the inputs are valide before procceding
      if (!v.value.$invalid) {
        // Emit and event with the registration user obj
        emitter("on-register-submit", {
          email: userEmail.value,
          username: userName.value,
          password: userPassword.value,
        });
        return;
      }
      // Todo: call a toaster
      console.log("Rejected");
    };

    return {
      userEmail,
      userName,
      userPassword,
      v,
      handleBlur,
      handleOnSubmit,
      userIcon: iconN.USER,
      lockIcon: iconN.LOCK,
      mailIcon: iconN.MAIL,
    };
  },
  emits: ["on-register-submit"],
};
